export default __webpack_public_path__ + "6bd0589a27236471fdabef8423794713.svg";